import React from 'react';
import * as Inovx from '@shared';
import RoleActions from '../actions/RoleActions';
import RoleStore from '../stores/RoleStore';
import RoleConstants from '../constants/RoleConstants';
import ExternalGroupSelect from './ExternalGroupSelect';

var SystemActions = Inovx.Shared.System.Actions;
var SystemStore = Inovx.Shared.System.Store;
var InovxControls = Inovx.Shared.Controls;

declare var InovxLoader: any;

interface LinkedRoleFormProps {
}

interface LinkedRoleFormState {
    isAdding?: boolean;
    isEditing?: boolean;

    allRoles?: IOrganizationRole[];
    role?: IOrganizationRole | any;
    linkedExternalGroups?: IExternalGroup[]

    isActionInProgress?: boolean;
    actionInProgressMsg?: string;

    validation?: IValidationDictionaryObject;
    displaySelectGroup?: boolean;
}

function getIsActionInProgress(): boolean {
    return SystemStore.isActionInProgress(RoleConstants.ROLE_ADD) ||
        SystemStore.isActionInProgress(RoleConstants.ROLE_EDIT);
}

var _actionInProgressMsg: string;
var _displaySelectGroupState: boolean;

function getLinkedRoleFormState(): LinkedRoleFormState {
    return {
        isAdding: RoleStore.getIsAdding(),
        isEditing: RoleStore.getIsEditing(),

        allRoles: RoleStore.getAll(),
        role: RoleStore.getRole(),

        isActionInProgress: getIsActionInProgress(),
        actionInProgressMsg: _actionInProgressMsg,

        displaySelectGroup: _displaySelectGroupState,
        linkedExternalGroups: RoleStore.getRole().LinkedExternalGroups,

        validation: RoleStore.getValidation(RoleConstants.ROLE_ADD_FORM)
    };
}

class LinkedRoleForm extends React.Component<LinkedRoleFormProps, LinkedRoleFormState> {
    constructor(props: LinkedRoleFormProps) {
        super(props);

        this.state = getLinkedRoleFormState();
        _actionInProgressMsg = InovxLoader.t("role:form.saving");
        _displaySelectGroupState = false;
    }

    private _saveRole = () => {
        if (this.state.role.IsLinkedRole && this.state.linkedExternalGroups.length == 0) {
            var checkMessage = InovxLoader.t('role:message.linkedGroupEmpty');
            var messageObject = {
                message: checkMessage
            }
            SystemActions.displayWarningMessage(messageObject);
        }
        else {
            if (this.state.isAdding) {
                RoleActions.createRole();
            } else {
                RoleActions.editRole();
            }
        }
    }

    private _cancel = () => {
        RoleActions.finishEdit();
    }

    private _loadState = () => {
        this.setState(getLinkedRoleFormState());
    }

    private _onChange = (event: any) => {
        RoleActions.editCurrentRole(RoleConstants.ROLE_ADD_FORM, event.target.name, event.target.value);
    }

    private _systemChange = () => {
        this.setState({ isActionInProgress: getIsActionInProgress() });
    }

    private _checkForUnsavedChanges = (event: any) => {
        if (RoleStore.getHasChanges()) {
            event.returnValue = InovxLoader.t("common:msgBox.browserSaveChanges");
        };
    }

    private _displayGroupSearch = () => {
        this.setState({ displaySelectGroup: true });
    }
    private _removeExternalGroup = (e: Event, group: IExternalGroup) => {
        RoleActions.deleteExternalGroup(group);
    }

    private _validateExternalGroup = (group: IExternalGroup) => {
        var assignedGroups = this.state.linkedExternalGroups;
        var messageObject: any = {
            message: InovxLoader.t("role:message.duplicateGroup")
        };
        var dupGroup: string = null;

        for (var j = 0; j < assignedGroups.length; j++) {
            var assignedGroup = assignedGroups[j];
            if (group.ID === assignedGroup.ID) {
                dupGroup = group.DisplayName;
                break;
            }
        }
        messageObject.message += dupGroup;
        if (dupGroup) SystemActions.displayWarningMessage(messageObject);
    }

    private _addExternalGroup = (group: IExternalGroup) => {
        this._validateExternalGroup(group);
        if (group) {
            RoleActions.addExternalGroup(group);
        }
    }

    private _closeSelectGroup = () => {
        _displaySelectGroupState = false;
        this.setState({
            displaySelectGroup: _displaySelectGroupState
        });
    }

    componentDidMount() {
        RoleStore.addChangeListener(this._loadState);
        SystemStore.addChangeListener(this._systemChange);
        window.addEventListener('beforeunload', this._checkForUnsavedChanges);
    }

    componentWillUnmount() {
        RoleStore.removeChangeListener(this._loadState);
        SystemStore.removeChangeListener(this._systemChange);
        window.removeEventListener('beforeunload', this._checkForUnsavedChanges);
    }

    render() {

        var inputObj = {
            className: 'form-control',
            type: 'text'
        }

        var role = this.state.role;

        var roleNameInput = {
            ...inputObj,
            name: 'Name',
            id: 'roleApp-name-input',
            value: role.Name
        };

        var roleDescriptionInput = {
            ...inputObj,
            name: 'Description',
            id: 'roleApp-desc-input',
            value: role.Description
        };

        var header = this.state.isAdding ? InovxLoader.t('role:header.newLinkedRole') : InovxLoader.t('role:header.editRole');

        var linkedGroupNameLabel = InovxLoader.t('role:form.linkedGroup');

        var columns = [{
            field: "DisplayName",
            headerText: InovxLoader.t('role:grid.name'),
            type: "string"
        }];

        var commands = {
            command: [
                {
                    iconClassName: 'glyphicon glyphicon-trash',
                    className: 'grid-button',
                    click: this._removeExternalGroup
                }],
            width: "85px",
            headerText: InovxLoader.t('role:grid.commands')
        };
        var defaultSort = [{
            field: "DisplayName",
            dir: "ascending"
        }];

        return (
            <InovxControls.StaticHeaderForm title={header} saveOnClick={this._saveRole} saveBtnId="roleApp-save-btn" cancelOnClick={this._cancel} cancelBtnId="roleApp-cancel-btn"
                isActionInProgress={this.state.isActionInProgress} inProgressMessage={this.state.actionInProgressMsg} >

                <div className="row role-linked-group">
                    <div className="col-sm-12">
                        <div className="form-field">
                            <label className="control-label">{`${linkedGroupNameLabel}*`}</label>
                        </div>
                        <div>
                            <Inovx.Shared.Controls.Grid dataSource={this.state.linkedExternalGroups} commands={commands} columns={columns}
                                defaultSort={defaultSort} />
                            <a id="roleApp-addLinkedGroup-btn" onClick={this._displayGroupSearch} style={{ height: "34px", marginTop: "8px" }} className="btn btn-info" >{InovxLoader.t("role:form.searchDirectory")}</a>
                        </div>
                    </div>
                </div>

                <InovxControls.FormField title={`${InovxLoader.t("role:common.roleName")}*`} inputName='Name'>
                    <InovxControls.ValidationInput {...roleNameInput} className="form-control" onChange={this._onChange} validation={this.state.validation['Name']} />
                </InovxControls.FormField>

                <InovxControls.FormField title={InovxLoader.t("role:common.description")} inputName='Description'>
                    <textarea {...roleDescriptionInput} onChange={this._onChange} />
                </InovxControls.FormField>

                <InovxControls.ModalPopUp isOpen={this.state.displaySelectGroup} >
                    <ExternalGroupSelect onSelect={this._addExternalGroup} onCancel={this._closeSelectGroup} />
                </InovxControls.ModalPopUp>

            </InovxControls.StaticHeaderForm>
        );
    }
}

export default LinkedRoleForm;
